export enum MenuActionType {
    TOGGLE = '@menu/TOGGLE',
    OPEN = '@menu/OPEN',
    CLOSE = '@menu/CLOSE'
}

export type MenuState = {
    open: boolean;
};
